import { Inject } from '@odinjs/odin';

import StipulatorContext from '@philips-emr/hpms-stipulator-commons/lib/contexts/stipulator-context';
import { FetchAPI } from '@philips-emr/tws-components';
import Controller, { OnBeforeFetch, OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';

import BaseController from '../BaseController';

@Controller({ fragment: 'inconsistencies-beneficiario' })
class InconsistenciesBeneficiarioLote extends BaseController {

  @Inject('fetch-inconsistencias')
  private fetchInconsistencias: FetchAPI;

  @OnMount({ target: 'layout-inconsistencias' })
  onMountInconsistencias(): void {
    const { endpoint } = this.context.getBulkData();

    this.fetchInconsistencias.setEndpoint(endpoint as string);
    this.fetchInconsistencias.forceFetch();
  }

  @OnBeforeFetch({ target: 'fetch-inconsistencias' })
  onBeforeFetch(event: MountEvent): void {
    const fetch = event.target as unknown as FetchAPI;
    const { nrSeqSubestipulante } = StipulatorContext.getCurrentContract();
    nrSeqSubestipulante && fetch.setParameters({ ...fetch.getParameters(), nrSeqSubestipulante });
  }
  
}

export default InconsistenciesBeneficiarioLote;
